module.exports = __webpack_public_path__ + "img/cover.ec648e6e.jpg";